module.exports = __webpack_public_path__ + "static/media/banner4.78d39cb4.jpg";